<template>
  <div class="nav">
    <div class="trade">
      <h5 @click="flag=!flag">第二十一届中国国际石油石化技术装备展览会
        <i class="iconfont icon-below-line"></i>
      </h5>
      <ul class="navUL" v-show="flag">
        <li>
          <span>展会时间：</span>
          <span>2021/03/30-20201/04/01</span>
        </li>
        <li>
          <span>展会地址：</span>
          <span>北京 · 中国国际展览中心</span>
        </li>
        <li>
          <span>主办单位：</span>
          <span>振威展览股份</span>
        </li>
        <li>
          <span>组织单位：</span>
          <span>北京振威展览有限公司</span>
        </li>
      </ul>
    </div>
    <ul class="navList">
      <li @click="()=>this.$router.push('/home/abouts')">
        <img src="http://www.cippe.com.cn/miniprogram/navbg01.png" alt=""/>
        <p>展会概况</p>
      </li>
      <li>
        <img src="http://www.cippe.com.cn/miniprogram/navbg02.png" alt=""/>
        <p>门票获取</p>
      </li>
      <li @click="()=>this.$router.push('/home/planning')">
        <img src="http://www.cippe.com.cn/miniprogram/navbg03.png" alt=""/>
        <p>展馆规划</p>
      </li>
      <li @click="()=>this.$router.push('/home/activities')">
        <img src="http://www.cippe.com.cn/miniprogram/navbg04.png" alt=""/>
        <p>同期活动</p>
      </li>
      <li @click="()=>this.$router.push('/supply')">
        <img src="http://www.cippe.com.cn/miniprogram/navbg05.png" alt=""/>
        <p>供需对接</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      flag:false,
    }
  }
}
</script>

<style scoped>
  img{
    width: 100%;
  }
  .nav{
    margin-left: -10px;
    margin-right: -10px;
    padding: 10px;
    background-color: white;
    
  }
  .trade h5{
    color: #000;
    font-weight: 600;
    font-size: 13px;
    line-height: 25px;
  }
  .trade h5 i{
    float: right;
  }
  .navUL{
    padding: 15px 0 10px;
    font-size: 14px;
  }
  .navUL li{
    padding: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
    color: #808080;
  }
  .navList{
    width: 100%;
    padding-top: 20px;
  }
  .navList li{
    display: inline-block;
    box-sizing: border-box;
    padding: 0 9px;
    width: 20%;
    text-align: center;
  }
  .navList li img{
    width: 100%;
    border-radius: 50%;
    font-size: 12px;
  }
  .navList li p{
    padding-top: 20px;
    font-size: 12px;

  }
</style>